import { memo, type ComponentProps } from 'react';
import { Input, Tooltip } from 'antd';
import {
  EyeInvisibleOutlined,
  EyeOutlined,
  KeyOutlined,
} from '@ant-design/icons';
import styles from './style.module.css';
import { APP_PASSWORD_HINT_TEXT } from './credentialPolicy';

export type AppPasswordInputProps = ComponentProps<typeof Input.Password> & {
  onGeneratePassword?: () => void;
  showHint?: boolean;
  hintText?: string;
  hintClassName?: string;
};

const AppPasswordInput = memo(
  ({
    onGeneratePassword,
    showHint = false,
    hintText = APP_PASSWORD_HINT_TEXT,
    hintClassName,
    ...props
  }: AppPasswordInputProps) => (
    <div>
      <Input.Password
        {...props}
        iconRender={(visible) => (
          <span>
            <Tooltip title={visible ? 'Скрыть пароль' : 'Показать пароль'}>
              {props.iconRender ? (
                props.iconRender(visible)
              ) : visible ? (
                <EyeOutlined />
              ) : (
                <EyeInvisibleOutlined />
              )}
            </Tooltip>
          </span>
        )}
        suffix={
          <>
            {onGeneratePassword ? (
              <Tooltip title="Сгенерировать пароль">
                <button
                  type="button"
                  className={styles.generateButton}
                  aria-label="Сгенерировать пароль"
                  disabled={props.disabled || props.readOnly}
                  onClick={onGeneratePassword}
                >
                  <KeyOutlined />
                </button>
              </Tooltip>
            ) : null}
            {props.suffix}
          </>
        }
      />
      {showHint ? <span className={hintClassName}>{hintText}</span> : null}
    </div>
  ),
);

AppPasswordInput.displayName = 'AppPasswordInput';

export default AppPasswordInput;
